import dayjs from 'dayjs'

const format = "MM/DD/YYYY"
const dateToString = date => date ? dayjs(date).format(format).toString() : null
const stringToDate = date => date ? dayjs(date).toDate() : null

export { dateToString, stringToDate}